export const LOAD_USER = '[USER]: Load user';
